import React from "react";

export const columns = () => {
  return [
    {
      accessorKey: "code",
      header: "ID",
      cell: ({ row }) => <div>{row.getValue("code")}</div>,
    },
  ];
};
